/* tslint:disable */

declare var Object: any;
export interface CardInterface {
  "id"?: string;
  "userId": number;
  "orderId": string;
  "referenceNumber"?: string;
  "planType": string;
  "productType": string;
  "status": number;
  "dateCreated": Date;
  activations?: any[];
  order?: any;
}

export class Card implements CardInterface {
  "id": string;
  "userId": number;
  "orderId": string;
  "referenceNumber": string;
  "planType": string;
  "productType": string;
  "status": number;
  "dateCreated": Date;
  activations: any[];
  order: any;
  constructor(data?: CardInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Card`.
   */
  public static getModelName() {
    return "Card";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Card for dynamic purposes.
  **/
  public static factory(data: CardInterface): Card{
    return new Card(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Card',
      plural: 'Cards',
      path: 'Cards',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "orderId": {
          name: 'orderId',
          type: 'string'
        },
        "referenceNumber": {
          name: 'referenceNumber',
          type: 'string'
        },
        "planType": {
          name: 'planType',
          type: 'string'
        },
        "productType": {
          name: 'productType',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number',
          default: 0
        },
        "dateCreated": {
          name: 'dateCreated',
          type: 'Date'
        },
      },
      relations: {
        activations: {
          name: 'activations',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'cardId'
        },
        order: {
          name: 'order',
          type: 'any',
          model: '',
          relationType: 'belongsTo',
                  keyFrom: 'orderId',
          keyTo: 'id'
        },
      }
    }
  }
}
